import React, { useState, FormEvent } from 'react'

interface LoginPageProps {
  alert?: string
  notice?: string
  emailAddress?: string
}

const LoginPage: React.FC<LoginPageProps> = ({ alert, notice, emailAddress = '' }) => {
  const [email, setEmail] = useState(emailAddress)
  const [password, setPassword] = useState('')

  const handleSubmit = (_e: FormEvent<HTMLFormElement>) => {
    // Let the form submit naturally to Rails
    // No preventDefault needed
  }

  const handleGoogleSignIn = () => {
    window.location.href = '/auth/google_oauth2'
  }

  return (
    <div className="login-page">
      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <h1>Sign in</h1>
          </div>

          {alert && (
            <div className="alert-message alert-error">{alert}</div>
          )}
          {notice && (
            <div className="alert-message alert-notice">{notice}</div>
          )}

          <form
            className="login-form"
            action="/session"
            method="post"
            onSubmit={handleSubmit}
          >
            <input
              type="hidden"
              name="authenticity_token"
              value={document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ''}
            />

            <div className="form-group">
              <input
                type="email"
                name="email_address"
                className="form-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <input
                type="password"
                name="password"
                className="form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                maxLength={72}
              />
            </div>

            <button type="submit" className="submit-button">
              Sign in
            </button>

            <div className="forgot-password">
              <a href="/password/new">Forgot password?</a>
            </div>
          </form>

          <div className="divider">or</div>

          <button onClick={handleGoogleSignIn} className="google-button">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
              <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z" fill="#34A853"/>
              <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.426 0 9.003 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fill="#EA4335"/>
            </svg>
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
